import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';

@Component({
  selector: 'app-dropdown-with-text-editor',
  templateUrl: './dropdown-with-text-editor.component.html',
  styleUrls: ['./dropdown-with-text-editor.component.scss']
})
export class DropdownWithTextEditorCellRendererComponent implements ICellEditorAngularComp, AfterViewInit {
  @ViewChild('inputField') inputField!: ElementRef;
  @ViewChild(MatAutocompleteTrigger) autoTrigger!: MatAutocompleteTrigger;
  params: any;
  values: any[] = [];
  inputControl = new FormControl('');
  filteredValues$!: Observable<(string | { isCreateNew: boolean; label: string })[]>;

  agInit(params: any): void {
    this.params = params;
    this.values = Array.isArray(params.values) ? this.sortByNameIfExists(params.values) : [];
    this.inputControl.setValue(params?.value || '');
    this.filteredValues$ = this.inputControl.valueChanges.pipe(
      startWith(this.inputControl.value || ''),
      map(value => {
        const filtered = this._filter(value || '');
        if (value === params?.value) {
          return filtered
        } else {
          return [{ isCreateNew: true, label: `Create New Site '${value}'` }, ...filtered];
        }

      })
    );

    Promise.resolve().then(() => {
      if (this.inputField?.nativeElement && this.autoTrigger) {
        this.inputField.nativeElement.focus();
        this.autoTrigger.openPanel();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.autoTrigger) {
      this.autoTrigger.openPanel();
    }
    if (this.params?.value) {
      this.inputField.nativeElement.value = this.params.value;
    }
  }

  onOptionSelected(event: any): void {
    const selected = event.option.value;

    if (!selected || selected.trim() === '') {
      this.inputControl.setValue(this.params.value);
      this.params.stopEditing();
      return;
    }

    if (typeof selected === 'string') {
      const selectedItem = this.values.find(item => item.name === selected);
      if (selectedItem) {
        this.params.updateRow(selectedItem, this.params.node.rowIndex, this.params.data);
      } else {
        this.params.updateRow({ name: selected }, this.params.node.rowIndex, this.params.data);

        if (this.params.createNewSite) {
          this.params.createNewSite(selected);
        }
      }
      this.params.stopEditing();
    }
  }


  getValue(): any {
    return this.inputControl.value;
  }

  isPopup(): boolean {
    return false;
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    if (value == this.params?.value) {
      return this.values.map(item => item.name)
    } else {
          return this.values
          .map(item => item.name)
          .filter(name => name.toLowerCase().includes(filterValue));
    }

  }

  sortByNameIfExists(array: any[]): any[] {
    if (!Array.isArray(array) || array.length === 0) {
      return array;
    }
    const firstItem = array[0];

    if (firstItem && typeof firstItem === 'object' && 'name' in firstItem) {
      return [...array].sort((a, b) => {
        const aName = String(a.name || '');
        const bName = String(b.name || '');
        return aName.localeCompare(bName);
      });
    }

    return array;
  }
}
